export const model = {
    fields: {
        name: {
            isRequired: true
        },
        productId: {
            isRequired: true
        },
        density: {
            isRequired: true
        }
    }
}